export default __webpack_public_path__ + "images/93b08303b8eb2f5d14478fb36a845fd8-august_banner_mobile.webp";